import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Cart from './components/Cart';
import BranchSelectModal, { getStoredBranch } from './components/BranchSelectModal';
import './App.css';
import Home from './pages/Home';
import Products from './pages/Products';
import CategoryProducts from './pages/CategoryProducts';
import ProductDetailPage from './pages/ProductDetailPage';
import CombosPage from './pages/CombosPage';
import ComboDetailPage from './pages/ComboDetailPage';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import ExtrasPage from './pages/ExtrasPage';
import ExtraDetailPage from './pages/ExtraDetailPage';
// Test

/**
 * Modal de sede a nivel app: obligatorio en cualquier ruta si no hay sede.
 */
function BranchGate() {
  const location = useLocation();
  const [showBranchModal, setShowBranchModal] = useState(() => !getStoredBranch());

  useEffect(() => {
    setShowBranchModal(!getStoredBranch());
  }, [location.pathname]);

  useEffect(() => {
    const sync = () => setShowBranchModal(!getStoredBranch());
    window.addEventListener('branchUpdated', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('branchUpdated', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  if (!showBranchModal) return null;

  return (
    <BranchSelectModal onBranchSelected={() => setShowBranchModal(false)} />
  );
}

function App() {
  return (
    <CartProvider>
      <Router>
        <BranchGate />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categorias" element={<Products />} />
          <Route path="/categorias/extras" element={<ExtrasPage />} />
          <Route path="/extra/:extraId" element={<ExtraDetailPage />} />
          <Route path="/productos" element={<Products />} />
          <Route path="/products" element={<Products />} />
          <Route path="/categorias/:category" element={<CategoryProducts />} />
          <Route path="/productos/:category" element={<CategoryProducts />} />
          <Route path="/producto/:productId" element={<ProductDetailPage />} />
          <Route path="/combos" element={<CombosPage />} />
          <Route path="/combos/:category" element={<CombosPage />} />
          <Route path="/combo/:comboId" element={<ComboDetailPage />} />
          <Route path="/nosotros" element={<AboutUsPage />} />
          <Route path="/contactanos" element={<ContactUsPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-tracking/:trackingToken" element={<OrderTrackingPage />} />
        </Routes>
        <Cart />
      </Router>
    </CartProvider>
  );
}

export default App;
